var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Select, Button, Empty, Spin, Tooltip } from "antd";
import { DashboardApi } from "../../../../../core/api/dashboardApi";
import "./RoadMap.scss";
import "./TableTree.scss";
import Header from "../../../../../layout/components/common/header";
import PageDescription from "../../../../../layout/components/common/pageDescription";
import localize from "../../../../../core/utils/translation-files";
import RoadmapTree from "./roadmapTree";
import { DASHBOARD_INDEX_DESCRIPTION } from "../../../../../config/constants";
import PrintButton from "../../../../../layout/components/common/PrintButton";
import UsePrintPage from "../../../../../core/hooks/usePrintPage";
import { NotificationApi } from "../../../../../core/api/notificationApi";
import html2canvas from "html2canvas";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { PdfContent } from "../../../../../layout/components/customPdfContent";
import $ from "jquery";
import DownloadDataLoader from "../../../../../layout/components/customPdfContent/DownloadDataLoader";
import { SessionStorage } from "../../../../../core/helpers/localStorage/sessionStorage";
import { SessionVariables } from "../../../../../core/constants/SessionVariables";
import isActionAllowed from "../../../../../core/authorization/userPermissions";
import { USER_REPORTS, USER_REPORTS_FINANCIAL, } from "../../../../../core/constants/permissionConstants";
import isEmpty from "../../../../../core/helpers/isEmpty";
import { fetchOverviewGlobalSearch } from "../../../../../redux/globalSearch/actions";
import { DashboardVariables } from "../../../../../core/constants/DashboardConstants";
const { getKey } = SessionStorage;
const SEARCH_DEBOUNCE_MS = 2000;
const MIN_LEN = 3;
const safeTrim = (v) => (typeof v === "string" ? v.trim() : "");
const RoadMapContainer = () => {
    const dispatch = useDispatch();
    const [apiCount, setApiCount] = useState(SessionStorage.getKey(SessionVariables.OVERVIEW_API_COUNT) !== undefined
        ? SessionStorage.getKey(SessionVariables.OVERVIEW_API_COUNT)
        : 0);
    const [treeData, setTreeData] = useState([]);
    const [bandData, setBandData] = useState({});
    const [count, setCount] = useState({});
    const { handlePrint, nodeRef } = UsePrintPage(true);
    const [financialData, setFinancialData] = useState([]);
    const [searchName, setSearchName] = useState("");
    const [optsName, setOptsName] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState(undefined);
    const [loadingName, setLoadingName] = useState(false);
    const debounceName = useRef(null);
    const itemsMapRef = useRef(new Map());
    const roadmapTreeRef = useRef(null);
    const searchRequestIdRef = useRef(0);
    const [companyIdForFinancialData, setCompanyIdForFinancialData] = useState([]);
    const resetOverviewSearch = () => {
        var _a;
        (_a = document.querySelectorAll(`.active-highlight-item`)[0]) === null || _a === void 0 ? void 0 : _a.classList.remove("active-highlight-item");
    };
    const breadcrumbLine = (item) => {
        var _a;
        return ((_a = item === null || item === void 0 ? void 0 : item.breadCrumb) !== null && _a !== void 0 ? _a : [])
            .sort((a, b) => DashboardVariables.CATEGORY_ORDER.indexOf(a.category) -
            DashboardVariables.CATEGORY_ORDER.indexOf(b.category))
            .map((b) => b === null || b === void 0 ? void 0 : b.name)
            .filter(Boolean)
            .join(" / ");
    };
    const handleSearch = (value) => __awaiter(void 0, void 0, void 0, function* () {
        resetOverviewSearch();
        const val = safeTrim(value);
        setSearchName(val);
        if (debounceName.current)
            window.clearTimeout(debounceName.current);
        if (!val || val.length < MIN_LEN) {
            setOptsName([]);
            itemsMapRef.current.clear();
            setLoadingName(false);
            return;
        }
        debounceName.current = window.setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            // Increment request ID to track the latest request
            searchRequestIdRef.current += 1;
            const currentRequestId = searchRequestIdRef.current;
            try {
                setLoadingName(true);
                const data = yield dispatch(fetchOverviewGlobalSearch({
                    searchType: "reportName",
                    keyword: val,
                    limit: 20,
                }));
                if (currentRequestId === searchRequestIdRef.current) {
                    const items = Array.isArray(data) ? data : [];
                    setOptsName(items);
                    // Store items in a map for easy retrieval
                    itemsMapRef.current.clear();
                    items.forEach((item) => {
                        const key = String((item === null || item === void 0 ? void 0 : item.id) || (item === null || item === void 0 ? void 0 : item.name));
                        itemsMapRef.current.set(key, item);
                    });
                }
            }
            catch (error) {
                console.error("Search error:", error);
                if (currentRequestId === searchRequestIdRef.current) {
                    setOptsName([]);
                    itemsMapRef.current.clear();
                }
            }
            finally {
                if (currentRequestId === searchRequestIdRef.current)
                    setLoadingName(false);
            }
        }), SEARCH_DEBOUNCE_MS);
    });
    // When a search option is selected, expand the tree based on breadcrumb hierarchy
    const onSelectName = (value) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const selectedItem = itemsMapRef.current.get(value);
        if (!selectedItem) {
            console.error("Selected item not found in map for value:", value);
            return;
        }
        setSelectedItemId(value);
        setSearchName(selectedItem.name || value);
        const crumbs = Array.isArray(selectedItem.breadCrumb)
            ? selectedItem.breadCrumb
            : [];
        if (!crumbs.length) {
            console.warn("No breadcrumbs found for selected item");
            return;
        }
        try {
            // Call the expansion function to programmatically expand the tree
            if (roadmapTreeRef.current) {
                const key = (_a = crumbs[0]) === null || _a === void 0 ? void 0 : _a.id;
                yield roadmapTreeRef.current.expandByBreadcrumb(crumbs);
                document
                    .querySelector(`[data-row-key="${(_b = crumbs[(crumbs === null || crumbs === void 0 ? void 0 : crumbs.length) - 1]) === null || _b === void 0 ? void 0 : _b.id}"]`).classList.add("active-highlight-item");
                (_c = document
                    .querySelector(`[data-row-key="${key}"]`)) === null || _c === void 0 ? void 0 : _c.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error("expandByBreadcrumb failed:", e);
        }
    });
    function extractCompanyIds(data, categories) {
        let ids = [];
        data.forEach((item) => {
            if (categories.includes(item.category))
                ids.push(item.companyId);
            if (item.children && Array.isArray(item.children))
                ids = ids.concat(extractCompanyIds(item.children, categories));
        });
        return ids;
    }
    const loadDashboardRoadmapData = (list) => {
        const allCompanyIds = [
            ...new Set([
                ...extractCompanyIds(list, ["Group", "Company"]),
                ...companyIdForFinancialData,
            ]),
        ];
        setCompanyIdForFinancialData(allCompanyIds);
        if (allCompanyIds.length)
            DashboardApi.getBandsInfoForCompanyFinancials(allCompanyIds, true)
                .then(setFinancialData)
                .catch(() => { });
        const mapId = list
            .map(({ key }) => key)
            .filter((id) => !Object.keys(notificationCountListId).includes(String(id)))
            .filter(Boolean);
        if (!mapId.length)
            return;
        setApiCount((p) => p + 1);
        DashboardApi.getbandInfo(mapId, true)
            .then((response) => {
            setApiCount((p) => p - 1);
            const resp = {};
            response === null || response === void 0 ? void 0 : response.forEach((i) => Object.assign(resp, { [i === null || i === void 0 ? void 0 : i.itemId]: i }));
            setBandData((pr) => (Object.assign(Object.assign({}, pr), resp)));
            setApiCount((p) => p + 1);
            NotificationApi.getNotificationsByRoadMapListId(mapId, list[0].category).then((res) => {
                setApiCount((p) => p - 1);
                setNotificationCountListId((pr) => (Object.assign(Object.assign({}, pr), res)));
            });
        })
            .catch(() => {
            setApiCount((p) => p - 1);
            const resp = {};
            mapId.forEach((i) => Object.assign(resp, { [i]: "empty" }));
            setBandData((pr) => (Object.assign(Object.assign({}, pr), resp)));
        });
        setApiCount((p) => p + 1);
        NotificationApi.getAllNotificationCount(mapId, true).then((r) => {
            setApiCount((p) => p - 1);
            setCount((pr) => (Object.assign(Object.assign({}, pr), r)));
        });
    };
    const getNotificationCountBIdList = (list, isExpandAll) => {
        loadDashboardRoadmapData(list);
        if (isExpandAll)
            list.forEach((n) => {
                var _a;
                return ((_a = n === null || n === void 0 ? void 0 : n.children) === null || _a === void 0 ? void 0 : _a.length) &&
                    getNotificationCountBIdList(n.children, isExpandAll);
            });
    };
    const [notificationCountListId, setNotificationCountListId] = useState({});
    useEffect(() => {
        const data = getKey(SessionVariables.TREE_EXPANDED_STATE, sessionStorage);
        if (!(treeData === null || treeData === void 0 ? void 0 : treeData.length) && !data) {
            setApiCount((p) => p + 1);
            DashboardApi.getRoadMapData().then((res) => {
                setApiCount((p) => p - 1);
                setTreeData(res);
                getNotificationCountBIdList(res);
                getSummaryFlagByTrackItemListAPI(res);
            });
        }
        else if (!isEmpty(data)) {
            getNotificationCountBIdList(data);
            getSummaryFlagByTrackItemListAPI(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { title, description } = DASHBOARD_INDEX_DESCRIPTION !== null && DASHBOARD_INDEX_DESCRIPTION !== void 0 ? DASHBOARD_INDEX_DESCRIPTION : {};
    const [pdfContent, setPdfContent] = useState(null);
    const [loadingData, setLoadingData] = useState(false);
    const [loadingProgress, setLoadingProgress] = useState(0);
    const loadAllData = () => {
        $("#expandAll").click();
        setLoadingData(true);
        setLoadingProgress(0);
        const timer = setInterval(() => {
            var _a;
            setLoadingProgress((lp) => (lp >= 70 ? lp : lp + 5));
            if (SessionStorage.getKey(SessionVariables.OVERVIEW_API_COUNT) === 0) {
                clearInterval(timer);
                html2canvas(document.querySelector(".tableTree"), {
                    scale: ((_a = document.querySelector(".tableTree")) === null || _a === void 0 ? void 0 : _a.scrollHeight) > 4500
                        ? 1.25
                        : 2,
                }).then((canvas) => {
                    const imgData = canvas.toDataURL("image/png");
                    setPdfContent(imgData);
                    setLoadingProgress(100);
                });
            }
        }, 4000);
    };
    useEffect(() => {
        if (pdfContent)
            setTimeout(() => {
                $(".downloadChat button").click();
                setLoadingData(false);
                setPdfContent(null);
            }, 2000);
    }, [pdfContent]);
    useEffect(() => {
        SessionStorage.setKey(SessionVariables.OVERVIEW_API_COUNT, apiCount);
    }, [apiCount]);
    const [summarySheetResponse, setSummarySheetResonse] = useState({});
    const isReportViewAllowed = isActionAllowed([USER_REPORTS]);
    const isFinancialDataViewAllowed = isActionAllowed([USER_REPORTS_FINANCIAL]);
    const getSummaryFlagByTrackItemListAPI = (list) => {
        if (isReportViewAllowed && isFinancialDataViewAllowed) {
            const mapId = list.map(({ key }) => key);
            if (mapId.length)
                DashboardApi.getSummaryFlagByTrackItemList(mapId, `${list[0].category}-financial`).then((response) => {
                    setSummarySheetResonse((prev) => (Object.assign(Object.assign({}, prev), response)));
                });
        }
    };
    return (React.createElement("div", null,
        React.createElement(Header, { leftComponent: React.createElement("h4", null, localize(["DashboardMenus.overview"])), rightComponent: React.createElement("div", { className: "header-center" },
                React.createElement("div", { className: "header-center-inner" },
                    React.createElement(Select, { className: "overview-ac", showSearch: true, allowClear: true, value: selectedItemId, placeholder: "Search (Type at least 3 characters)", style: { width: 420 }, defaultActiveFirstOption: false, showArrow: false, getPopupContainer: (triggerNode) => triggerNode.parentNode, filterOption: false, dropdownMatchSelectWidth: false, dropdownClassName: "overview-ac-dropdown", notFoundContent: loadingName ? (React.createElement("div", { style: { padding: "8px", textAlign: "center" } },
                            React.createElement(Spin, { size: "small" }),
                            " ",
                            React.createElement("span", null, "Searching\u2026"))) : searchName.length >= MIN_LEN ? (React.createElement(Empty, { description: "No results" })) : (React.createElement(Empty, { description: `Type at least ${MIN_LEN} characters` })), onSearch: handleSearch, onChange: (value) => {
                            resetOverviewSearch();
                            if (value === null || value === undefined) {
                                setSelectedItemId(undefined);
                                setSearchName("");
                            }
                            else {
                                onSelectName(value);
                            }
                        }, loading: loadingName, optionLabelProp: "label" }, !loadingName &&
                        optsName.map((item) => {
                            const value = String((item === null || item === void 0 ? void 0 : item.id) || (item === null || item === void 0 ? void 0 : item.name));
                            return (React.createElement(Select.Option, { key: value, value: value, label: item === null || item === void 0 ? void 0 : item.name },
                                React.createElement("div", { className: "overview-ac-option" },
                                    React.createElement("div", { className: "title", "data-title": item === null || item === void 0 ? void 0 : item.name }, item === null || item === void 0 ? void 0 : item.name),
                                    React.createElement(Tooltip, { placement: "topLeft", title: React.createElement("div", { className: "crumbs", style: { fontSize: "10px", color: "#999" }, "data-title": breadcrumbLine(item) }, breadcrumbLine(item)) },
                                        React.createElement("div", { className: "crumbs", style: { fontSize: "12px", color: "#999" }, "data-title": breadcrumbLine(item) }, breadcrumbLine(item))))));
                        })),
                    React.createElement(PrintButton, { printOnClick: handlePrint }),
                    React.createElement(Button, { type: "primary", onClick: loadAllData, id: "downloadBtn", key: `${loadingData}`, disabled: loadingData }, loadingData ? "Downloading..." : "Download"),
                    React.createElement(PDFDownloadLink, { fileName: "Overview Data", className: "downloadChat d-none", document: React.createElement(PdfContent, { image: pdfContent }) },
                        React.createElement(Button, { onClick: null })))) }),
        React.createElement(PageDescription, { title: title, description: description }),
        React.createElement(DownloadDataLoader, { percent: loadingProgress, loadingData: loadingData, screen: "overview", callBack: () => setApiCount(0) }),
        React.createElement("div", { ref: nodeRef },
            React.createElement(RoadmapTree, { ref: roadmapTreeRef, treeData: treeData, setTreeData: setTreeData, bandData: bandData, setBandData: setBandData, count: count, setCount: setCount, getNotificationCountBIdList: getNotificationCountBIdList, notificationCountListId: notificationCountListId, setNotificationCountListId: setNotificationCountListId, financialData: financialData, summarySheetResponse: summarySheetResponse, getSummaryFlagByTrackItemListAPI: getSummaryFlagByTrackItemListAPI }))));
};
export default RoadMapContainer;
